import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=5ea9565e&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=ts"
export * from "./IconPicker.vue?vue&type=script&lang=ts"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=5ea9565e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9565e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea9565e')) {
      api.createRecord('5ea9565e', component.options)
    } else {
      api.reload('5ea9565e', component.options)
    }
    module.hot.accept("./IconPicker.vue?vue&type=template&id=5ea9565e&scoped=true", function () {
      api.rerender('5ea9565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/IconPicker.vue"
export default component.exports